import { type FSLocale } from '@fshr/shared';

export default function getTollFreeNumbersLink(locale: FSLocale) {
	switch (locale) {
		case 'es':
		case 'fr':
		case 'zh':
			return `${process.env['NEXT_PUBLIC_WEBSITE_BASE_URL']}/${locale}/global_toll_free_telephone_numbers/`;

		default:
			return `${process.env['NEXT_PUBLIC_WEBSITE_BASE_URL']}/global_toll_free_telephone_numbers/`;
	}
}
